import type { InjectionKey } from 'vue'

/* provided by block.vue, so a child drawn inside a card reads as card copy instead of a chat bubble */
export const IS_IN_CARD: InjectionKey<boolean> = Symbol('isInCard')
